<template lang="pug">
v-card(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import { VCard } from 'vuetify/lib';

export default {
  components:  { VCard },
  props: {},
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      return {
        outlined: true,
        class: 'dv-card',
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-card {
  &.v-card.v-sheet {
    border-radius: 16px;
    padding: 16px;
  }
  &.v-sheet--outlined {
    border: #{$ui-neutral-border};
  }
}
</style>
